<template>
	<div class="">
		<div class="config-row">
			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						TTL
						<span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.graph_ttl?.tooltip"
							data-bs-toggle="tooltip" data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.graph_ttl?.editable" type="button" class="btn btn-sm btn-secondary"
							@click="resetToInitial('graph_ttl')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>

				</div>
				<input type="text" class="form-control" v-model="config.graph_ttl" @input="updateConfig"
					:disabled="!fieldInfo?.graph_ttl?.editable"
					:placeholder="fieldInfo?.graph_ttl?.editable ? fieldInfo?.graph_ttl?.placeholder : ''" />
			</div>

			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Cluster Type
						<span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.choose_cluster_type?.tooltip"
							data-bs-toggle="tooltip" data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.choose_cluster_type?.editable" type="button"
							class="btn btn-sm btn-secondary" @click="resetToInitial('choose_cluster_type')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<input type="text" class="form-control" v-model="config.choose_cluster_type" @input="updateConfig"
					:disabled="!fieldInfo?.choose_cluster_type?.editable"
					:placeholder="fieldInfo?.choose_cluster_type?.editable ? fieldInfo?.choose_cluster_type?.placeholder : ''" />
			</div>

			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Cluster Domain
						<span class="fa fa-circle-info text-muted ms-1"
							:title="fieldInfo?.choose_cluster_domain?.tooltip" data-bs-toggle="tooltip"
							data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.choose_cluster_domain?.editable" type="button"
							class="btn btn-sm btn-secondary" @click="resetToInitial('choose_cluster_domain')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<input type="text" class="form-control" v-model="config.choose_cluster_domain" @input="updateConfig"
					:disabled="!fieldInfo?.choose_cluster_domain?.editable"
					:placeholder="fieldInfo?.choose_cluster_domain?.editable ? fieldInfo?.choose_cluster_domain?.placeholder : ''" />
			</div>
		</div>

		<div class="config-row mb-3 pb-1">
			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Weightage Map
						<span class="fa fa-circle-info text-muted ms-1"
							:title="fieldInfo?.create_cluster_weightage_map?.tooltip" data-bs-toggle="tooltip"
							data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.create_cluster_weightage_map?.editable" type="button"
							class="btn btn-sm btn-secondary" @click="resetToInitial('create_cluster_weightage_map')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<div v-if="config.create_cluster_weightage_map.length > 0">
							<div v-for="(item, index) in config.create_cluster_weightage_map" :key="index" class="mb-2">
								<div class="input-group mb-1">
									<input type="text" class="form-control" :value="item.key" style="flex: 3;"
										@input="updateMapKey('create_cluster_weightage_map', index, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_weightage_map?.editable"
										placeholder="Key" />
									<input :type="'number'" class="form-control" :value="item.value" style="flex: 1;"
										@input="updateMapValue('create_cluster_weightage_map', index, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_weightage_map?.editable" />
									<button v-if="fieldInfo?.create_cluster_weightage_map?.editable" type="button"
										class="btn btn-sm btn-outline-danger"
										@click="removeMapEntry('create_cluster_weightage_map', index); updateConfig()">
										<i class="fa fa-trash"></i>
									</button>
								</div>
							</div>
						</div>
						<div v-else>
							<p class="text-muted">No data found!</p>
						</div>
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<span class="text-danger" v-if="weightageMapError">{{ weightageMapError }}</span>
							</div>
							<div>
								<button v-if="fieldInfo?.create_cluster_weightage_map?.editable" type="button"
									class="btn btn-sm btn-primary mt-2 btn-primary"
									@click="addMapEntry('create_cluster_weightage_map'); updateConfig()">
									<i class="fa fa-plus"></i> Add Entry
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						TTL Maps
						<span class="fa fa-circle-info text-muted ms-1"
							:title="fieldInfo?.create_cluster_ttl_maps?.tooltip" data-bs-toggle="tooltip"
							data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.create_cluster_ttl_maps?.editable" type="button"
							class="btn btn-sm btn-secondary" @click="resetToInitial('create_cluster_ttl_maps')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<div v-if="config.create_cluster_ttl_maps.length > 0">
							<div v-for="(item, index) in config.create_cluster_ttl_maps" :key="index" class="mb-2">
								<div class="input-group mb-1">
									<input type="text" class="form-control" :value="item.key" style="flex: 3;"
										@input="updateMapKey('create_cluster_ttl_maps', index, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_ttl_maps?.editable" placeholder="Key" />
									<input :type="'number'" class="form-control" :value="item.value" style="flex: 1;"
										@input="updateMapValue('create_cluster_ttl_maps', index, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_ttl_maps?.editable" />
									<div class="hours-box">
										<span class="hoursbox-text">h</span>
									</div>
									<button v-if="fieldInfo?.create_cluster_ttl_maps?.editable" type="button"
										class="btn btn-sm btn-outline-danger"
										@click="removeMapEntry('create_cluster_ttl_maps', index); updateConfig()">
										<i class="fa fa-trash"></i>
									</button>
								</div>
							</div>
						</div>
						<div v-else>
							<p class="text-muted">No data found!</p>
						</div>
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<span class="text-danger" v-if="ttlMapError">{{ ttlMapError }}</span>
							</div>
							<div>
								<button v-if="fieldInfo?.create_cluster_ttl_maps?.editable" type="button"
									class="btn btn-sm btn-primary mt-2 btn-primary"
									@click="addMapEntry('create_cluster_ttl_maps'); updateConfig()">
									<i class="fa fa-plus"></i> Add Entry
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="config-row" v-if="fieldInfo?.invalid_values?.editable">
			<div class="config-field config-field-full">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Invalid IDs
						<span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.invalid_values?.tooltip"
							data-bs-toggle="tooltip" data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button type="button" class="btn btn-sm btn-secondary"
							@click="resetToInitial('invalid_values')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<div v-if="invalid_values?.length > 0">
							<div v-for="(item, index) in invalid_values" :key="index" class="input-group mb-2">
								<input type="text" class="form-control" v-model="invalid_values[index]"
									@input="updateConfig" :disabled="!fieldInfo?.invalid_values?.editable"
									:placeholder="item == null ? 'null' : 'invalid value'" />
								<button v-if="fieldInfo?.invalid_values?.editable" type="button"
									class="btn btn-sm btn-outline-danger"
									@click="removeArrayItem('invalid_values', index); updateConfig()">
									<i class="fa fa-trash"></i>
								</button>
							</div>
						</div>
						<div v-else>
							<p class="text-muted">No data found!</p>
						</div>
						<div class="d-flex justify-content-end align-items-center">
							<button v-if="fieldInfo?.invalid_values?.editable" type="button"
								class="btn btn-sm btn-primary mt-2 btn-primary"
								@click="addArrayItem('invalid_values'); updateConfig()">
								<i class="fa fa-plus"></i> Add ID
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ClusterConfigEasyMode',
	data() {
		return {
			config: {
				graph_ttl: "",
				create_cluster_weightage_map: {},
				create_cluster_ttl_maps: {},
				choose_cluster_type: "",
				choose_cluster_domain: ""
			},
			isLoadingFromParent: false,
			invalid_values: JSON.parse(JSON.stringify(this.fieldInfo.invalid_values.initialValue)),
			ttlMapError: "",
			weightageMapError: "",
		};
	},
	props: {
		modelValue: {
			type: Object,
			default: () => ({})
		},
		fieldInfo: {
			type: Object,
			default: () => ({})
		},
		cleanConfigFn: {
			type: Function,
			required: true
		},
	},
	watch: {
		modelValue: {
			handler(newVal, oldVal) {
				// Only load config if it's actually different (not just a reference change)
				// This prevents overwriting local changes when switching tabs
				if (newVal && typeof newVal === 'object' && Object.keys(newVal).length > 0) {
					// Check if the config has actually changed by comparing key values
					if (!oldVal || !this.isConfigEqual(newVal, oldVal)) {
						this.isLoadingFromParent = true;
						this.loadConfig(newVal);
						this.$nextTick(() => {
							this.isLoadingFromParent = false;
						});
					}
				}
			},
			deep: true,
			immediate: false
		},
		invalid_values: {
			handler(newVal, oldVal) {
				this.$emit('invalidValuesChange', newVal);
			},
			deep: true,
			immediate: false
		}
	},
	beforeMount() {
		if (this.modelValue && typeof this.modelValue === 'object' && Object.keys(this.modelValue).length > 0) {
			this.loadConfig(this.modelValue);
		}
	},
	methods: {
		isConfigEqual(config1, config2) {
			// Deep comparison to check if configs are actually different
			if (!config1 || !config2) return false;
			const keys1 = Object.keys(config1);
			const keys2 = Object.keys(config2);
			if (keys1.length !== keys2.length) return false;

			for (let key of keys1) {
				if (JSON.stringify(config1[key]) !== JSON.stringify(config2[key])) {
					return false;
				}
			}
			return true;
		},
		updateConfig() {
			// Emit updated config to parent to maintain state
			// Don't emit if we're currently loading from parent (prevents infinite loop)
			if (!this.isLoadingFromParent) {
				const configObj = this.cleanConfigFn(this.config);
				this.$emit('update:modelValue', configObj);
			}
		},
		loadConfig(value) {
			if (!value || typeof value !== 'object') {
				return;
			}

			// Initialize config with prop values or defaults
			const weightageMap = [];
			if (value.create_cluster_weightage_map && Array.isArray(value.create_cluster_weightage_map)) {
				value.create_cluster_weightage_map.forEach(item => {
					let key = item.key;
					let val = item.value;

					try {
						if (val === true || val === false || val === null || val === undefined) {
							val = 0;
						} else if (typeof val === 'string') {
							val = val.trim();
							if (val.toLowerCase() == "inf") {
								val = -1;
							} else if (val.match(/^\d+[hH]$/)) {
								if (val.includes('.')) {
									val = parseFloat(val);
								} else {
									val = parseInt(val);
								}
							} else {
								val = isNaN(val) ? 0 : Number(val);
							}
						} else {
							val = isNaN(val) ? 0 : Number(val);
						}
					} catch (e) {
						console.log("Error parsing value in weightage map for key(", key, ") : ", e);
						val = 0;
					}

					weightageMap.push({
						key: key,
						value: val
					});
				});
			}

			const ttlMaps = [];
			if (value.create_cluster_ttl_maps && Array.isArray(value.create_cluster_ttl_maps)) {
				value.create_cluster_ttl_maps.forEach(item => {
					let key = item.key;
					let val = item.value;

					try {
						if (val === true || val === false || val === null || val === undefined) {
							val = 0;
						} else if (typeof val === 'string') {
							val = val.trim();
							if (val.toLowerCase() == "inf") {
								val = -1;
							} else if (val.match(/^\d+[hH]$/)) {
								if (val.includes('.')) {
									val = parseFloat(val);
								} else {
									val = parseInt(val);
								}
							} else {
								val = isNaN(val) ? 0 : Number(val);
							}
						} else {
							val = isNaN(val) ? 0 : Number(val);
						}
					} catch (e) {
						console.log("Error parsing value in ttl map for key(", key, ") : ", e);
						val = 0;
					}

					ttlMaps.push({
						key: key,
						value: val
					});
				});
			}

			this.config = {
				graph_ttl: value.graph_ttl || "",
				create_cluster_weightage_map: weightageMap,
				create_cluster_ttl_maps: ttlMaps,
				choose_cluster_type: value.choose_cluster_type || "",
				choose_cluster_domain: value.choose_cluster_domain || ""
			};
			
			// Check for duplicates in ttl maps and weightage maps since they are implemented as arrays
			this.checkDuplicates("create_cluster_weightage_map");
			this.checkDuplicates("create_cluster_ttl_maps");
		},
		resetToInitial(fieldName) {
			if (this.modelValue && typeof this.modelValue === 'object' && Object.keys(this.modelValue).length > 0) {
				if (fieldName == "invalid_values") {
					this.invalid_values = JSON.parse(JSON.stringify(this.fieldInfo[fieldName].initialValue));
				} else {
					let config = JSON.parse(JSON.stringify(this.modelValue));
					config[fieldName] = JSON.parse(JSON.stringify(this.fieldInfo[fieldName].initialValue));
					this.loadConfig(config);
				}
				this.updateConfig();
			}
		},
		addMapEntry(fieldName) {
			if (this.config[fieldName].some(item => item.key === "")) {
				return;
			}
			this.config[fieldName].push({
				key: "",
				value: 0
			});
		},
		updateMapKey(fieldName, index, newKey) {
			const row = this.config[fieldName][index];
			if (this.config[fieldName][index]) {
				row.key = newKey;
			}
		},
		updateMapValue(fieldName, index, value) {
			const row = this.config[fieldName][index];
			if (row) {
				row.value = value;
			}
		},
		removeMapEntry(fieldName, index) {
			if (!index || index < 0 || index >= this.config[fieldName].length) return;
			this.config[fieldName].splice(index, 1);
		},
		addArrayItem(fieldName) {
			if (fieldName == "invalid_values") {
				this.invalid_values.push("");
			} else {
				if (!Array.isArray(this.config[fieldName])) {
					this.config[fieldName] = [];
				}
				this.config[fieldName].push("");
			}
		},
		removeArrayItem(fieldName, index) {
			if (fieldName == "invalid_values") {
				this.invalid_values.splice(index, 1);
			} else {
				this.config[fieldName].splice(index, 1);
			}
		},
		checkDuplicates(fieldName) {
			const uniqueMap = new Map();
			const duplicateKeys = new Set();
			this.config[fieldName].forEach(item => {
				if (uniqueMap.has(item.key)) {
					duplicateKeys.add(item.key);
					return true; // Found a duplicate
				} else {
					uniqueMap.set(item.key, true);
					return false;
				}
			});
			if (duplicateKeys.size > 0) {
				if (fieldName == "create_cluster_weightage_map") this.weightageMapError = `Duplicate ${duplicateKeys.size == 1 ? "key" : "keys"} found : ` + Array.from(duplicateKeys).map(key => `'${key}'`).join(", ");
				else this.ttlMapError = `Duplicate ${duplicateKeys.size == 1 ? "key" : "keys"} found : ` + Array.from(duplicateKeys).map(key => `'${key}'`).join(", ");
			} else {
				if (fieldName == "create_cluster_weightage_map") this.weightageMapError = "";
				else this.ttlMapError = "";
			}
		},
	},
	emits: ["update:modelValue", "resetToInitial", "invalidValuesChange"],
};
</script>

<style scoped>
.config-row {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 1rem;
	margin-bottom: 1rem;
}

.config-row:first-child .config-field {
	flex: 1 1 calc(33.333% - 0.67rem);
	min-width: 200px;
}

.config-row:nth-child(2) .config-field {
	flex: 1 1 calc(50% - 0.5rem);
	min-width: 300px;
}

.config-field {
	padding: 0.7rem;
	background-color: #fafafa;
	border-radius: 4px;
	box-sizing: border-box;
	box-shadow: 4px 4px 4px rgb(234, 234, 234);
}

.config-field-full {
	flex: 1 1 100%;
}

@media (max-width: 992px) {
	.config-row:first-child .config-field {
		flex: 1 1 calc(50% - 0.5rem);
	}
}

@media (max-width: 768px) {

	.config-row:first-child .config-field,
	.config-row:nth-child(2) .config-field {
		flex: 1 1 100%;
	}
}

.input-group {
	display: flex;
	align-items: stretch;
}

.input-group .form-control {
	flex: 1;
}

.form-label {
	font-size: 0.75rem;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.form-select {
	max-width: 100px;
	background-color: #f6f6f6;
}

.card {
	margin-bottom: 0rem;
}

.hours-box {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 25px;
	background-color: #f6f6f6;
	border: 1px solid #d3d8da;
	border-left: none;
	border-right: none;
}

.hoursbox-text {
	font-weight: bold;
	color: #666;
}
</style>